import styles from './CardSkeleton.module.scss';

export interface ICardSkeletonProps {
    margin?: string;
    minimumHeight?: number;
}

const CardSkeleton: React.FC<ICardSkeletonProps> = (props: ICardSkeletonProps) => (
    <div className={styles.card_skeleton} style={{ margin: props.margin, minHeight: props.minimumHeight }} />
);

export default CardSkeleton;
